import React, { useEffect, useState } from "react";
import "./CurrentDayChart.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
} from "recharts";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useLanguage } from "../../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard5,
  reset_current_total_bar5,
  reset_current_total_line5,
  reset_current_vs_actual_budget_bar5,
  reset_current_vs_actual_budget_line5,
  reset_expense_bar_chart,
  reset_expense_bar_chart5,
  reset_expense_line_chart,
  reset_expense_line_chart5,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph5,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph5,
  reset_kanban_data,
  reset_kanban_data5,
  reset_open_acc_receive,
  reset_open_acc_receive5,
  reset_profit_line_chart,
  reset_profit_line_chart5,
  reset_sales_line_chart,
  reset_sales_line_chart5,
  reset_task_at_risk5,
  reset_task_complete_status5,
  reset_task_deviation_analysis5,
  reset_tax_line5,
  reset_tax_pie5,
  reset_transaction_dashboard5,
  set_balance_dashboard5,
  set_current_total_bar5,
  set_current_total_line5,
  set_current_vs_actual_budget_bar5,
  set_current_vs_actual_budget_line5,
  set_expense_bar_chart,
  set_expense_bar_chart5,
  set_expense_line_chart,
  set_expense_line_chart5,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph5,
  set_expense_per_line_graph,
  set_expense_per_line_graph5,
  set_open_acc_receive,
  set_open_acc_receive5,
  set_profit_line_chart,
  set_profit_line_chart5,
  set_sales_line_chart,
  set_sales_line_chart5,
  set_task_at_risk5,
  set_task_complete_status5,
  set_task_deviation_analysis5,
  set_tax_line5,
  set_tax_pie5,
  set_transaction_dashboard5,
  toggle_Kanban_data,
  toggle_Kanban_data5,
} from "../../../../redux/reducers/favDashboardSlice";
import HttpClient from "../../../../utils/HttpClient";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import DashboardManager5 from "../../dashboard/DashboardManager5";
import RiskManagement from "../../../TaskManager/RiskManagement";
import Loader from "../../../../Loader/Loader";
import { useSelector } from "react-redux";
import RiskManagement5 from "../../../TaskManager/RiskManagement5";

const data = [
  { name: "Revenue", value: 10000, color: "#b3b3b3" },
  { name: "Expense", value: 0, color: "#1b2d41" },
  { name: "Profit", value: 10000, color: "#0c2d48" },
];

const CurrentDayChart = () => {
  const { taskCompletionStatus5, taskAtRisk5, taskDeviationAnalysis5 } =
    useSelector((state) => state?.favDashboard);

  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();
  const [widgetsFive, setwidgetsFive] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchWidgetOneData = async () => {
    try {
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setwidgetsFive(res?.widgets?.five || []);
      } else {
        console.log("error", res);
        setwidgetsFive([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsFive) {
      setSelectedWidgetOne(widgetsFive?.find((item) => item?.visible) || null);
    }
  }, [widgetsFive]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data5());
      dispatch(reset_open_acc_receive5());
      dispatch(reset_expense_per_line_graph5());
      dispatch(reset_expense_per_bar_graph5());
      dispatch(reset_expense_bar_chart5());
      dispatch(reset_expense_line_chart5());
      dispatch(reset_profit_line_chart5());
      dispatch(reset_sales_line_chart5());
      dispatch(reset_task_complete_status5());
      dispatch(reset_task_deviation_analysis5());
      dispatch(reset_task_at_risk5());
      dispatch(reset_current_total_bar5());
      dispatch(reset_current_total_line5());
      dispatch(reset_current_vs_actual_budget_bar5());
      dispatch(reset_current_vs_actual_budget_line5());
      dispatch(reset_transaction_dashboard5());
      dispatch(reset_balance_dashboard5());
      dispatch(reset_tax_line5());
      dispatch(reset_tax_pie5());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data5());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive5());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph5());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph5());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart5());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart5());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart5());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart5());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status5());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis5());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk5());
          break;
        case "current total (bar graph)":
          dispatch(set_current_total_bar5());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line5());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar5());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line5());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard5());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard5());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie5());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line5());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        setSelectedWidgetOne(widget);
        closeModal();
        fetchWidgetOneData();
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  return (
    <>
      <div className="chart-wrapper-dc">
        {!selectedWidgetOne && (
          <Loader />
          // <div></div>
        )}
        <div className="header-dc">
          <h2 className="title-dc">
            {selectedWidgetOne?.name?.toUpperCase() ||
              "CURRENT DAY TOTAL"?.toUpperCase()}
          </h2>

          <div className="icons-dc">
            <i
              className="fa-regular fa-pen-to-square icon-dc"
              onClick={openModal}
            ></i>
            {/* <i className="fa-solid fa-trash icon-dc"></i> */}
          </div>
        </div>

        {/* Render the widget based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager5 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement5
            taskCompleteStatus={taskCompletionStatus5}
            taskAtRisk={taskAtRisk5}
            taskDeviationAnalysis={taskDeviationAnalysis5}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement5
            taskCompleteStatus={taskCompletionStatus5}
            taskAtRisk={taskAtRisk5}
            taskDeviationAnalysis={taskDeviationAnalysis5}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement5
            taskCompleteStatus={taskCompletionStatus5}
            taskAtRisk={taskAtRisk5}
            taskDeviationAnalysis={taskDeviationAnalysis5}
          />
        )}

        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager5 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager5 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager5 />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase() ||
                "Select Widget"?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsFive?.length > 0 ? (
                widgetsFive.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CurrentDayChart;
